import React from 'react';
import MyNavbar from '../components/MyNavbar';
import Footer from '../components/Footer';
import { Container, Row, Col, Card, Carousel } from 'react-bootstrap';

const News = () => {
  const newsItems = [
    {
      id: 11,
      title: "Outstanding PhD Alumni Award from MUIDSI!",
      date: "2026",
      content:
      "Proud to celebrate our WV-INBRE PI, Dr. Trupti Joshi, for receiving the Outstanding PhD Alumni Award from MUIDSI. A well-deserved honor recognizing her outstanding contributions and leadership in the field. Wishing her many more achievements!",
      images: [
        "/images/newsImages/phd-alumni-award1.jpg",
        "/images/newsImages/phd-alumni-award2.png",
        "/images/newsImages/phd-alumni-award3.jpg"
      ],
      category: "Event",
      link: "#"
    },
    {
      id: 10,
      title: "Marshall Day at the Capitol: Mission Accomplished!",
      date: "2026",
      content:
      "A day of powerful conversations, proud moments, and reaffirming the vital bond between Marshall University and the state we call home. Thank you to the incredible Marshall delegation and our state's leaders for an impactful day. Together, we are building West Virginia's future.",
      images: [
        "/images/newsImages/marshall-day-capitol-1.jpeg",
        "/images/newsImages/marshall-day-capitol-2.jpeg",
        "/images/newsImages/marshall-day-capitol-3.jpeg"
      ],
      category: "Event",
      link: "#"
    },
    {
      id: 9,
      title: "WV-INBRE Research Featured on WOWK TV",
      date: "2025",
      content:
        "When local research makes the news, it’s worth celebrating. A huge shout-out to WV-INBRE PI Trupti Joshi for her impactful work in AI for healthcare, recently highlighted by WOWK TV. The feature showcases how her research team is leveraging artificial intelligence to tackle complex challenges in biomedical science and advance innovation in healthcare across West Virginia.",
      images: [
        "/images/newsImages/wowk-tv-feature.png"
      ],
      category: "Media Coverage",
      link: "https://www.youtube.com/watch?v=yZNYn9xgHX4"
    },
    {
      id: 8,
      title: "AI-Powered Platforms & Integrative Omics Workshop at PAG 33",
      date: "January 2025",
      content:
        "It was wonderful to organize the \"AI-Powered Platforms and Integrative Omics for Next Generation Plant Systems Biology and Trait Engineering\" workshop at the PAG 33 Conference. Many thanks to all the speakers and participants for making it a great success. The workshop continues to stimulate collaborative ideas for the adoption and development of tools and methods for translational research.",
      images: [
        "/images/newsImages/PAG33-1.jpeg",
        "/images/newsImages/PAG33-2.jpeg",
        "/images/newsImages/PAG33-3.jpeg",
        "/images/newsImages/PAG33-4.jpeg",
        "/images/newsImages/PAG33-5.jpeg",
        "/images/newsImages/PAG33-6.jpeg",
        "/images/newsImages/PAG33-7.jpeg"
      ],
      category: "Workshop",
      link: "#"
    },
    {
      id: 7,
      title: "Biomedical Sciences Holiday Luncheon",
      date: "December 10, 2025",
      content:
        "Faculty, students, and staff came together to celebrate the season at the Biomedical Sciences Holiday Luncheon, fostering community, collaboration, and holiday spirit across the program.",
      images: [
        "/images/newsImages/holiday-lunch-1.jpeg",
        "/images/newsImages/holiday-lunch-2.jpeg"
      ],
      category: "Event",
      link: "#"
    },
    {
      id: 1,
      title: "37th Annual Health Sciences Research Day",
      date: "November 3, 2025",
      content: "Our lab participated in the 37th Annual Health Sciences Research Day at St. Mary's Center for Education, showcasing our latest research in biomedical informatics.",
      images: [
        "/images/newsImages/research-day-1.jpeg",
        "/images/newsImages/research-day-2.jpeg", 
        "/images/newsImages/research-day-3.jpeg"
      ],
      category: "Event",
      link: "#"
    },
    {
      id: 2,
      title: "GROW Webinar: Multi-Omics Data Integration",
      date: "April 2024",
      content: "Dr. Trupti Joshi presented on multi-omics data integration approaches and computational frameworks in the GROW webinar series.",
      images: [
        "/images/newsImages/grow-webinar.jpg"
      ],
      category: "Webinar",
      link: "https://digbio.missouri.edu/grow-webinar-multi-omics-data-integration-with-trupti-joshi/"
    },
    {
      id: 3,
      title: "Bioinformatics & Big Data Workshop",
      date: "March 2024",
      content: "Hands-on workshop covering bioinformatics tools, big data analysis, and computational methods for biological research.",
      images: [
        "/images/newsImages/bioinformatics-workshop.jpg"
      ],
      category: "Workshop",
      link: "https://digbio.missouri.edu/bioinformatics-big-data-workshop-2/"
    },
    {
      id: 4,
      title: "IAmScience with Trupti Joshi",
      date: "February 2024",
      content: "Featured interview discussing the journey in bioinformatics and the importance of computational biology in modern research.",
      images: [
        "/images/newsImages/iamscience.jpg"
      ],
      category: "Feature",
      link: "https://digbio.missouri.edu/iamscience-trupti-joshi/"
    },
    {
      id: 5,
      title: "MU Faculty Receive Pilot Funding for Translational Research",
      date: "January 2024",
      content: "Dr. Joshi awarded pilot funding for innovative translational research projects bridging computational and biomedical sciences.",
      images: [
        "/images/newsImages/funding-award.jpg"
      ],
      category: "Award",
      link: "https://digbio.missouri.edu/mu-faculty-members-receive-pilot-funding-for-translational-research/"
    },
    {
      id: 6,
      title: "SoyKB: Plant Biology meets Computer Science",
      date: "December 2023",
      content: "SoyKB knowledgebase highlighted as a powerful tool integrating plant biology with advanced computational approaches.",
      images: [
        "/images/newsImages/soykb-feature.jpg"
      ],
      category: "Publication",
      link: "https://digbio.missouri.edu/soykb-a-powerful-tool-at-the-junction-of-plant-biology-and-computer-science/"
    }
  ];

  const ImageDisplay = ({ images, title }) => {
    // Only show carousel if there are multiple images
    if (images.length > 1) {
      return (
        <Carousel 
          interval={null}
          indicators={true}
          controls={true}
          prevIcon={
            <span 
              aria-hidden="true" 
              style={{
                backgroundColor: 'rgba(10, 75, 93, 0.7)',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white'
              }}
            >
              ‹
            </span>
          }
          nextIcon={
            <span 
              aria-hidden="true" 
              style={{
                backgroundColor: 'rgba(10, 75, 93, 0.7)',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white'
              }}
            >
              ›
            </span>
          }
        >
          {images.map((img, index) => (
            <Carousel.Item key={index}>
              <div style={{
                height: '200px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f8f9fa'
              }}>
                <img
                  className="d-block"
                  src={img}
                  alt={`${title} ${index + 1}`}
                  style={{
                    maxHeight: '100%',
                    maxWidth: '100%',
                    objectFit: 'contain',
                    cursor: 'pointer'
                  }}
                  onClick={() => window.open(img, '_blank')}
                />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      );
    }
    
    // Single image display
    return (
      <div style={{
        height: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f8f9fa'
      }}>
        <img
          src={images[0]}
          alt={title}
          style={{
            maxHeight: '100%',
            maxWidth: '100%',
            objectFit: 'contain',
            cursor: 'pointer'
          }}
          onClick={() => window.open(images[0], '_blank')}
        />
      </div>
    );
  };

  return (
    <div>
      <MyNavbar />
      <section style={{
        backgroundColor: '#0A4B5D',
        color: 'white',
        paddingTop: '5rem',
        paddingBottom: '3rem'
      }}>
        <Container>
          <Row className="text-center">
            <Col lg={8} className="mx-auto">
              <h1 className="display-4 fw-bold mb-4">News & Events</h1>
              <p className="lead">
                Latest updates, achievements, and research highlights from Dr. Trupti Joshi's laboratory.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <div style={{ padding: '50px 0', minHeight: '80vh' }}>
        <Container>
          <Row xs={1} md={2} className="g-4">
            {newsItems.map((news) => (
              <Col key={news.id}>
                <Card className="h-100 shadow border-0">
                  {/* Image Display - carousel only for multiple images */}
                  <div style={{ height: '200px', overflow: 'hidden' }}>
                    {news.images && news.images.length > 0 ? (
                      <ImageDisplay images={news.images} title={news.title} />
                    ) : (
                      <div 
                        style={{
                          height: '200px',
                          backgroundColor: '#f8f9fa',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#6c757d'
                        }}
                      >
                        No Image Available
                      </div>
                    )}
                  </div>
                  
                  <Card.Body className="p-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <Card.Title 
                        style={{ 
                          color: '#0A4B5D', 
                          fontSize: '1.1rem',
                          marginBottom: '0.5rem'
                        }}
                      >
                        {news.title}
                      </Card.Title>
                      <span 
                        className="badge" 
                        style={{ 
                          backgroundColor: '#0A4B5D', 
                          color: 'white',
                          fontSize: '0.7rem'
                        }}
                      >
                        {news.category}
                      </span>
                    </div>
                    
                    <Card.Subtitle className="mb-2 text-muted small">
                      {news.date}
                    </Card.Subtitle>
                    
                    <Card.Text style={{ fontSize: '0.9rem', lineHeight: '1.4', flex: '1' }}>
                      {news.content}
                    </Card.Text>
                    
                    {news.link && news.link !== '#' && (
                      <div className="mt-auto pt-2">
                        <a 
                          href={news.link} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{
                            color: '#0A4B5D',
                            textDecoration: 'none',
                            fontSize: '0.8rem',
                            fontWeight: '500'
                          }}
                        >
                          Read more →
                        </a>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Quick Links */}
          <Row className="mt-5">
            <Col lg={12}>
              <Card className="border-0 text-center" style={{ backgroundColor: '#f8f9fa' }}>
                <Card.Body className="p-4">
                  <h5 style={{ color: '#0A4B5D' }} className="mb-3">
                    Follow Our Research
                  </h5>
                  <div>
                    <a 
                      href="https://scholar.google.com/citations?user=Pyt_mlAAAAAJ&hl=en&oi=ao" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="me-3"
                      style={{ color: '#0A4B5D', textDecoration: 'none', fontWeight: '500' }}
                    >
                      Google Scholar
                    </a>
                    <span className="me-3" style={{ color: '#0A4B5D' }}>|</span>
                    <a 
                      href="https://www.ncbi.nlm.nih.gov/myncbi/trupi.joshi.1/bibliography/public/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="me-3"
                      style={{ color: '#0A4B5D', textDecoration: 'none', fontWeight: '500' }}
                    >
                      PubMed
                    </a>
                    <span className="me-3" style={{ color: '#0A4B5D' }}>|</span>
                    <a 
                      href="https://www.linkedin.com/in/trupti-joshi-9552ba17/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ color: '#0A4B5D', textDecoration: 'none', fontWeight: '500' }}
                    >
                      LinkedIn
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default News;